import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Cookies from 'js-cookie';
import './CollapsibleSection.css';

const CollapsibleSection = ({ children, collapsedContent, openByDefault, cookiePreventState, fixed = false, overlay = false, enableHover = false, expandIcon = '+', position = { bottom: '1rem', right: '1rem' } }) => {
  const [isCollapsed, setIsCollapsed] = useState(openByDefault && Cookies.get(cookiePreventState) !== 'true');

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);

    if (cookiePreventState) {
      const newCookieState = Cookies.get(cookiePreventState) === 'true' ? 'false' : 'true';
      Cookies.set(cookiePreventState, newCookieState, { expires: 7 });
    }
  };

  const handleMouseEnter = () => {
    if (enableHover && !isCollapsed) {
      setIsCollapsed(true);
    }
  };

  const handleMouseLeave = () => {
    if (enableHover && isCollapsed) {
      setIsCollapsed(false);
    }
  };

  const containerStyle = fixed ? { position: 'fixed', ...position } : {};
  const overlayStyle = overlay ? { position: 'absolute', background: 'rgba(100, 100, 100, 0.5)', paddingRight: '0' } : {};

  return (
    <div 
      className={`collapsible-container`} 
      style={containerStyle}
      onMouseEnter={enableHover ? handleMouseEnter : null}
      onMouseLeave={enableHover ? handleMouseLeave : null}
    >
      <motion.div
        layout
        data-isopen={isCollapsed}
        initial={{ borderRadius: 20 }}
        className="instruction-parent"
        style={overlayStyle}
      >
        <motion.div
          layout
          className="instruction-child"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.8 }}
          onClick={toggleCollapse}
        >
          {isCollapsed ? '-' : expandIcon}
        </motion.div>
        {isCollapsed ? (
          <motion.div>
            {children}
          </motion.div>
        ) : (
          <motion.div onClick={toggleCollapse}>
            {collapsedContent}
          </motion.div>
        )}
      </motion.div>
    </div>
  );
};

export default CollapsibleSection;
